module.exports = __webpack_public_path__ + "static/cry-the-beloved-country-a3d1061f12b643dde62dc5625b9a0b05.jpg";